/**
 * @module runtime-warning
 * @description Centralizes production-only prototype warnings so adapter mocks
 * do not scatter direct console calls across runtime modules.
 */

export function warnRuntimeAdapterMock(message: string): void {
  const sink = globalThis.console;
  if (typeof sink?.warn === "function") {
    sink.warn(message);
  }
}
